export var IdAssetBundleThemedEvent;
(function (IdAssetBundleThemedEvent) {
    IdAssetBundleThemedEvent["Asian"] = "Asian";
    IdAssetBundleThemedEvent["Camping"] = "Camping";
    IdAssetBundleThemedEvent["Christmas"] = "Christmas";
    IdAssetBundleThemedEvent["Easter"] = "Easter";
    IdAssetBundleThemedEvent["Fairytale"] = "Fairytale";
    IdAssetBundleThemedEvent["FoodTruck"] = "FoodTruck";
    IdAssetBundleThemedEvent["FarmCup"] = "FarmCup";
    IdAssetBundleThemedEvent["Generic"] = "Generic";
    IdAssetBundleThemedEvent["Halloween"] = "Halloween";
    IdAssetBundleThemedEvent["Hawaii"] = "Hawaii";
    IdAssetBundleThemedEvent["Ufo"] = "Ufo";
    IdAssetBundleThemedEvent["Wedding"] = "Wedding";
})(IdAssetBundleThemedEvent || (IdAssetBundleThemedEvent = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleThemedEvent.ts
// module id = 732
// module chunks = 3